import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Button } from './Button';

import './Navbar.css';
import './Login.css';
import pbslogo from "./pbslogo.png";


function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true)

    const handleClick = () => setClick (!click);
    const closeMobileMenu = () => {
        setClick(false)
        window.scroll(0,0);
    };
    const showButton = () => {

        if(window.innerWidth <= 960){
            setButton(false);
        } else {
            setButton(true);
        }
    };

    useEffect(() => {
        showButton()
    }, []);

    window.addEventListener('resize', showButton);

    const [modal, setModal] = useState(false);
    const toggleModal = () => {
    setModal(!modal)
  };

  if(modal) {
    document.body.classList.add('active-modal')
  }
     else {
    document.body.classList.remove('active-modal')
  }


  return (

    <>
   <nav className='navbar'>
    <div className='navbar-container'>
    <Link to ="/" className= "navbar-logo" onClick={closeMobileMenu}><h1>PBS-BBS</h1>
    {/* <img className='pbslogo' src={pbslogo} alt="logo" title='PBS logo' /> */}
    </Link>
    <div className='menu-icon' onClick={handleClick}>
        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
    </div>
    <ul className= {click ? 'nav-menu active' : 'nav-menu'}>
        <li className='nav-item'>
            <Link to = '/' className= 'nav-links' onClick={closeMobileMenu}>
                Home
            </Link>
        </li>
        <li className='nav-item'>
            <Link to = '/about' className= 'nav-links' onClick={closeMobileMenu}>
                About
            </Link>


        </li>
        <li className='nav-item'>
            <Link to = '/stations' className= 'nav-links' onClick={closeMobileMenu}>
                Stations
            </Link>
        </li>
        {/* <li className='nav-item'>
            <Link to = '/transparencyseal' className= 'nav-links' onClick={closeMobileMenu}>
                Transparency Seal <i class="fa fa-caret-down"></i>
            </Link>

        </li> */}
        <li className='nav-item'>
            <Link to = '/contact' className= 'nav-links' onClick={closeMobileMenu}>
                Contact
            </Link>

        </li>
        <li className='nav-item'>

            {/* <Link to = '/' className= 'nav-links-mobile' onClick={toggleModal}>
                Login
            </Link> */}
            {modal && (
        <div className="modal">
          <div className="overlay" onClick={toggleModal} ></div>
          <div className="modal-content">
                <h2>Sign In</h2>
                <form action='#'>
                    <div className='input-box'>
                        <span className='icon'><i class="fa-solid fa-user"></i></span>
                        <input type='user' required/>
                        <label>Username</label>
                    </div>
                    <div className='input-box'>
                        <span className='icon'><i class="fa-solid fa-lock"></i></span>
                        <input type='password' required/>
                        <label>Password</label>
                    </div>
                    {/* <div className='remember-forgot'>
                        <label><input type='checkbox'>Remember me</input></label>
                        <a href='#'>Forgot password</a>
                    </div> */}
                    {/* <button className ='btnsubmit'type='submit' >Log In</button> */}

                </form>


        </div>
        </div>
        )}
        </li>
    </ul>
    {/* <button className= 'btn-modal2' onClick={toggleModal} >Log In</button> */}

    </div>
   </nav>
</>
  )
}

export default Navbar;